//@flow
import React from 'react';

import styles from './ItemTagIndicator.scss';

export const ItemTagIndicator = () => (
    <div className={styles.wrapper} data-tn="item-tag-indicator">
        <div className={`${styles.radius} ${styles.center}`} />
        <div className={`${styles.radius} ${styles.pulse}`} />
        <div className={`${styles.radius} ${styles.echo}`} />
    </div>
);
